module.exports = "../images/cabin3.jpg?v=fd1bea1";